<script>
import BaseButton from '@/Components/Buttons/BaseButton'

export default {
    components: {
        BaseButton
    },
    props: {
        notification: {
            type: Object,
            required: true
        }
    },
    emits: ['mark-read'],
    data() {
        return {
            textColor: '',
            bgColor: '',
            bgLight: ''
        }
    },
    computed: {
        theme() {
            return this.notification.notification.theme ?? 'blue'
        },
        cssVars() {
            switch (this.theme) {
            case 'red':
                return {
                    '--text-color': '#a94442',
                    '--bg-color': '#ebccd1',
                    '--bg-light': '#f2dede'
                }
            case 'green':
                return {
                    '--text-color': '#3c763d',
                    '--bg-color': '#d6e9c6',
                    '--bg-light': '#dff0d8'
                }
            case 'yellow':
                return {
                    '--text-color': '#D0763D',
                    '--bg-color': '#FFE9C6',
                    '--bg-light': '#FFF0D8'
                }
            default:
                return {
                    '--text-color': '#415a71',
                    '--bg-color': '#b9c8d8',
                    '--bg-light': '#dce4eb'
                }
            }

        }
    }
}
</script>

<template>
    <div
        :style="cssVars"
        class="flex relative flex-wrap mt-2.5 text-sm rounded-md border-2 shadow-md notification-wrap"
    >
        <div
            :style="cssVars"
            class="p-2.5 pr-5 w-full leading-none notification-header"
        >
            <i
                v-if="notification.notification.icon"
                :class="'mr-2 fa fa-' + notification.notification.icon"
            />
            <span>{{ notification.notification.title }}</span>
        </div>
        <div
            :class="notification.notification.two_column ? 'w-1/2' : 'w-full'"
            class="p-2.5 notification-message"
        >
            {{ notification.notification.message }}
        </div>
        <div
            :class="notification.notification.two_column ? 'p-2.5 w-1/2 space-y-2.5' : 'w-full flex gap-2.5'"
            class="px-2.5 pb-2.5 notification-buttons"
        >
            <a
                v-if="notification.notification.left_button"
                :class="notification.notification.two_column ? 'grow' : 'w-1/2'"
                :href="notification.notification.left_button.url"
                class="block"
                target="_blank"
            >
                <BaseButton
                    :variant="notification.notification.theme"
                    button-classes="text-xs w-full"
                >
                    {{ notification.notification.left_button.text }}
                </BaseButton>
            </a>
            <a
                v-if="notification.notification.right_button"
                :href="notification.notification.right_button.url"
                class="block grow"
                target="_blank"
            >
                <BaseButton
                    :variant="notification.notification.theme"
                    button-classes="text-xs w-full"
                >
                    {{ notification.notification.right_button.text }}
                </BaseButton>
            </a>
        </div>
        <div
            class="absolute top-1 right-2.5 cursor-pointer close-notification"
            @click="$emit('mark-read', notification.uid)"
        >
            <i class="fas fa-times" />
        </div>
    </div>
</template>

<style scoped>
.notification-wrap {
    color: var(--text-color);
    background: var(--bg-light);
    border-color: var(--bg-color);
}

.notification-header {
    background: var(--bg-color);
}
</style>
